import moment from 'moment'

import { c } from '../../../../translations/LibraryTranslationService'

export type TypeCustomRules = { [key: string]: string }

export type InputRule = {
  required?: boolean
  mandatory?: boolean
  data_type?:
    | 'string'
    | 'number'
    | 'boolean'
    | Date
    | 'integer'
    | 'float'
    | 'array'
  options?: TypeCustomRules | string[]
  validations?: string
  examples?: string[]
}

export const dateRegex = /^(\d{1,2})[-/](\d{1,2})[-/](\d{2,4})$/

// Check if object is empty
export const isObjectEmpty = (options = {}) => {
  return JSON.stringify(options) !== '{}'
}

// Data Type - Select
export const isSelect = (validationRules?: InputRule) =>
  validationRules?.data_type === 'string' &&
  validationRules?.options &&
  isObjectEmpty(validationRules?.options) &&
  Object.keys(validationRules?.options)?.length !== 0

// Data Type - Boolean
export const isBoolean = (validationRules?: InputRule) =>
  validationRules?.data_type === 'boolean' &&
  validationRules?.options &&
  isObjectEmpty(validationRules?.options) &&
  Object.keys(validationRules?.options)?.length !== 0

// Data Type - Date
export const isDate = (initialValue: string, validationRules?: InputRule) =>
  validationRules?.data_type === 'string' &&
  !validationRules?.options &&
  moment(initialValue, true)

export const isValidExampleDate = (dateString: string) => {
  const dateRegex =
    /^(?:(?:19|20)\d{2})-(?:(?:0[1-9]|1[0-2]))-(?:(?:0[1-9]|[12][0-9]|3[01]))$/
  return dateRegex.test(dateString)
}

const validExampleDateFormat = (examples?: string) => {
  return examples?.length ? isValidExampleDate(examples) : false
}

export const isValidDate = (
  initialValue: string,
  validationRules?: InputRule,
) => {
  const validExampleDate = validExampleDateFormat(
    validationRules?.examples?.[0],
  )
  const validationType = getValidationRules(
    validationRules?.validations as string,
  )

  if (
    validationRules?.data_type === 'string' &&
    !validationRules?.options &&
    (validExampleDate || validationType?.format === 'date')
  ) {
    const dateFormatConvert = moment(initialValue).format('YYYY-MM-DD')
    const isValidDateFormat = moment(dateFormatConvert)
    if (isValidDateFormat.isValid() && initialValue?.length > 6) {
      return true
    } else {
      return false
    }
  }
}

const onlyContainsNumbers = (value: string) => /^\d+$/.test(value)

const containsDecimal = (value: string) => /^\d+\.\d+$/.test(value)

export const validateInput = (
  inputValue: string,
  rule: InputRule,
  cellValidationRule: TypeCustomRules,
) => {
  if ((rule?.required && !inputValue) || (rule?.mandatory && !inputValue)) {
    return {
      valid: true,
      errorText: c('fieldRequired'),
    }
  }

  if (
    rule?.data_type === 'number' ||
    rule?.data_type === 'float' ||
    rule?.data_type === 'integer'
  ) {
    const checkvalueType =
      rule?.data_type === 'float'
        ? onlyContainsNumbers(inputValue) || containsDecimal(inputValue)
        : onlyContainsNumbers(inputValue)
    if (!checkvalueType) {
      return {
        valid: true,
        errorText: c('errorMustBeNumber'),
      }
    }
  }

  if (
    rule?.data_type === 'number' ||
    rule?.data_type === 'string' ||
    rule?.data_type === 'integer' ||
    rule?.data_type === 'float'
  ) {
    if (cellValidationRule) {
      if (
        cellValidationRule?.max &&
        inputValue?.length > Number(cellValidationRule?.max)
      ) {
        return {
          valid: true,
          errorText: c('errorLessThanXCharacters', {
            characterLength: cellValidationRule?.max,
          }),
        }
      }
      if (
        cellValidationRule?.min &&
        inputValue?.length < Number(cellValidationRule?.min)
      ) {
        return {
          valid: true,
          errorText: c('errorAtLeastXCharacters', {
            characterLength: cellValidationRule?.max,
          }),
        }
      }
    }
  }
}

export const getValidationRules = (rule: string) => {
  const rules: TypeCustomRules = {}
  const ruleObj = typeof rule === 'string' ? rule?.split(/[|]/) : []

  const ruleArray = ruleObj?.map((r) => {
    return r?.split(/[:]/)
  })

  ruleArray?.map((r) => {
    if (r?.length === 1) {
      rules['type'] = r?.[0]
    } else {
      rules[r?.[0]] = r?.[1]
    }
    return rules
  })

  return rules
}
